import React, { useRef } from 'react';
import { esconderNome, formatarTempo, cardProtocolo, cardCategoriaPaciente, camelCase, cardProbabilidadeInternacao } from '../../helpers/FormatHelpers';
import { buscarCorSLA } from '../../rules/regraSLA';

const CardMedicacaoDetalhe = ({ dataPacientes, dataProbabilidadeInternacao, tipoSelecionado, ps_tipo, selecionarPaciente }) => {

  const isInfantil = ps_tipo === 'infantil';
  const isPediatria = (item) => item.DESCRICAOESPECIALIDADE === 'PEDIATRIA';

  const pacientesAdulto = dataPacientes.filter((item) => !isPediatria(item));
  const pacientesInfantil = dataPacientes.filter((item) => isPediatria(item));

  const title = isInfantil ? 'PS Infantil' : 'PS Adulto';
  const pacientes = isInfantil ? pacientesInfantil : pacientesAdulto;
  const total = pacientes.length;

  return (
    <>
      <div className='card-pacientes'>
        <div className='card-grupo'>
          <div className='card-title'>{title}</div>
          <div className='card-title'>{total}</div>
        </div>
        <div className='card-header'>
          <table>
            <thead>
              <tr>
                <th>Class. de Risco</th>
                <th>Aguardando</th>
                <th>Paciente</th>
                <th>Nº atendimento</th>
                <th>Especialidade/Médico</th>
                <th style={{ textAlign: 'right' }}>Espera</th>
                <th style={{ textAlign: 'right' }}>Espera Total</th>
              </tr>
            </thead>
            <tbody>
              {pacientes.map((paciente, index) => {
                const espera = paciente.VALOR ?? 0;
                const esperaTotal = paciente.VALORTRIAGEM ?? espera;
                const corSLA = buscarCorSLA({ tipoCard: tipoSelecionado, tempo: espera, situacaoMedicacao: paciente.AGUARDANDO, tipoPaciente: ps_tipo });
								const especialidadeMedico = camelCase(`${paciente.DESCRICAOESPECIALIDADE} / ${paciente.NOMESOLICITANTE}`);
                const previsaointernacao = dataProbabilidadeInternacao.find(obj => (obj.codigoatendimento.split(' ')[1] == paciente.CODIGOATENDIMENTO))?.previsaointernacao ?? null;

                return (
                  <tr key={index}>
                    <td><div className={'alert-label ' + paciente.NOMECOR}></div></td>
                    <td style={{ fontWeight: '500' }}>{paciente.AGUARDANDO}</td>
                    <td>{esconderNome(paciente.NOMEPACIENTE)}{cardProtocolo(paciente.DOCUMENTOCLINICO)}{cardCategoriaPaciente(paciente.CATEGORIAPACIENTE)}{cardProbabilidadeInternacao(previsaointernacao)}</td>
                    <td style={{ fontWeight: '500' }}>
                      <a href="#" onClick={(e) => { e.preventDefault(); selecionarPaciente(paciente.CODIGOPACIENTE);}}> 
                        {paciente.CODIGOATENDIMENTO} 
                      </a>
                    </td>
                    <td style={{ fontWeight: '500', fontSize: '1.5vh' }}>{especialidadeMedico}</td>
                    <td className='col-espera' style={{ textAlign: 'right' }}>
                      <span className={"sla-dot " + corSLA}></span>
                      <span style={{ marginLeft: '10px' }}>{formatarTempo(espera)}</span>
                    </td>
                    <td style={{ textAlign: 'right' }}>{formatarTempo(esperaTotal)}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CardMedicacaoDetalhe;